const initState = {
  theme: "flame",
  busy: true,
};

const uiReducer = (state = initState, action) => {
  switch (action.type) {
    case "CHANGE_UI_THEME": {
      const nextTheme = state.theme === "flame" ? "experimentaldark" : "flame";
      localStorage.setItem("theme", JSON.stringify(nextTheme));
      return { ...state, theme: nextTheme };
    }

    case "SET_UI_THEME":
      return { ...state, theme: action.payload };

    case "SET_BUSY":
      return { ...state, busy: action.payload };

    default:
      return state;
  }
};

export default uiReducer;
